// Stock CARO background, shown on the home photo frame AND the screensaver when
// the resident has no photos of their own. Single source of truth for both.
export const DEFAULT_BACKGROUND_URL = 'https://caro.care/images/default.png';

// The system font for screens that must look the same under every resident theme (noodknop,
// alarm, emergency call, the emergency buttons). Without a theme `--caro-font-system` is not
// declared and this resolves to exactly what <body> paints (`--caro-font`, written by
// useBranding); a theme sets `--caro-font-system` so its body font never reaches these screens.
export const SYSTEM_FONT_STACK = 'var(--caro-font-system, var(--caro-font, system-ui, -apple-system, sans-serif))';
